import {
  buildHttpResponse,
  buildMultipartHttpResponse,
  HttpMethod,
} from "../../../Rest_api/Network_utility";
import { ApiResponse } from "../../../models/api_res";
import { getMonthFromDate } from "../../../extensions/date";
import {
  convertToRajasthanGenData,
  DailyDiscomDrawalSchedule,
  HarayanaDailyPeakData,
  RajashtanRrvpn,
  RajasthanCollective,
  RajasthanDiscomData,
  RajasthanDiscomDrawal,
  RajasthanGenData,
  RajasthanGnaTgna,
  RajasthanIsgs,
  RajasthanUploadFile,
  RajBankingData,
  RajGenParams,
  RajGenProfile,
  RajProcurement,
  RajProcurementRecord,
  RajSurplusDeficitData,
  RajTamData,
  ReEnergyData,
  GssLoadDailyDiscomResponse,
  GssLoadDailyDiscomItem,
} from "../../../models/rajasthan";
import { AnyCnameRecord } from "node:dns";

const API_BASE =
  process.env.REACT_APP_API_BASE || "https://gnai-agent.gna.energy";

export async function getRajasthanDiscomDrawlData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<RajasthanDiscomDrawal[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomDrawal?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    const uniqueDates = Array.from(new Set(response.map((item) => item[0])));
    return response.map((item) => {
      // Map discom codes to names
      const discomMap: Record<string, string> = {
        JDVVNL: "Jodhpur",
        JVVNL: "Jaipur",
        AVVNL: "Ajmer",
      };
      return {
        dateIndex: (uniqueDates.indexOf(item[0]) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        date: item[0],
        month: getMonthFromDate(item[0]),
        block: item[1],
        area: item[2],
        mw: item[3],
        lu: item[3] / 400,
        discom: discomMap[item[4]] || item[4],
        division: item[6],
        district: item[5],
        mwh: item[3] / 4,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getDemoRajasthanDiscomDrawlData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<RajasthanDiscomDrawal[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomDrawal?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    // derive uniques
    const uniqueDates = Array.from(new Set(response.map((item) => item[0])));
    const uniqueAreas = Array.from(new Set(response.map((item) => item[2])));
    const uniqueDistricts = Array.from(
      new Set(response.map((item) => item[5]))
    );
    const uniqueDivisions = Array.from(
      new Set(response.map((item) => item[6]))
    );

    // build generic maps
    const discomMap: Record<string, string> = {
      JDVVNL: "Discom 1",
      JVVNL: "Discom 2",
      AVVNL: "Discom 3",
    };
    const areaMap: Record<string, string> = {};
    uniqueAreas.forEach((a, i) => (areaMap[a] = `Area ${i + 1}`));
    const districtMap: Record<string, string> = {};
    uniqueDistricts.forEach((d, i) => (districtMap[d] = `District ${i + 1}`));
    const divisionMap: Record<string, string> = {};
    uniqueDivisions.forEach((v, i) => (divisionMap[v] = `Division ${i + 1}`));

    return response.map((item) => ({
      dateIndex: (uniqueDates.indexOf(item[0]) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      date: item[0],
      month: getMonthFromDate(item[0]),
      block: item[1],
      area: areaMap[item[2]] || item[2],
      mw: item[3],
      lu: item[3] / 400,
      discom: discomMap[item[4]] || item[4],
      district: districtMap[item[5]] || item[5],
      division: divisionMap[item[6]] || item[6],
      mwh: item[3] / 4,
    }));
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}
export async function dmrcChatGptRes({
  query,
  thread_token,
}: {
  query: string;
  thread_token: string;
}): Promise<{ sender: String; content: String }> {
  const response = await buildHttpResponse({
    endPoint: `dmrc/handeUserQuery?query=${query}&thread_token=${thread_token}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function createThread(): Promise<{ thread_token: string }> {
  const response = await buildHttpResponse({
    endPoint: `dmrc/create_thread`,
    method: HttpMethod.POST,
  });
  return response;
}

export async function getRajasthanDiscomDrawlForecastData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<RajasthanDiscomDrawal[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomDrawalForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    const uniqueDates = Array.from(new Set(response.map((item) => item[1])));
    return response.map((item) => {
      // Map discom codes to names
      const discomMap: Record<string, string> = {
        JDVVNL: "Jodhpur",
        JVVNL: "Jaipur",
        AVVNL: "Ajmer",
      };
      return {
        dateIndex: (uniqueDates.indexOf(item[1]) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        date: item[1],
        month: getMonthFromDate(item[1]),
        block: item[2],
        area: item[3],
        mw: item[4],
        lu: item[4] / 400,
        discom: discomMap[item[5]] || item[5],
        division: item[6],
        district: item[7],
        mwh: 0,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getDemoRajasthanDiscomDrawlForecastData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<RajasthanDiscomDrawal[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomDrawalForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    // derive uniques
    const uniqueDates = Array.from(new Set(response.map((item) => item[1])));
    const uniqueAreas = Array.from(new Set(response.map((item) => item[3])));
    const uniqueDiscoms = Array.from(new Set(response.map((item) => item[5])));
    const uniqueDivisions = Array.from(
      new Set(response.map((item) => item[6]))
    );
    const uniqueDistricts = Array.from(
      new Set(response.map((item) => item[7]))
    );

    // build generic maps
    const discomMap: Record<string, string> = {};
    uniqueDiscoms.forEach((d, i) => (discomMap[d] = `Discom ${i + 1}`));

    const areaMap: Record<string, string> = {};
    uniqueAreas.forEach((a, i) => (areaMap[a] = `Area ${i + 1}`));

    const divisionMap: Record<string, string> = {};
    uniqueDivisions.forEach((v, i) => (divisionMap[v] = `Division ${i + 1}`));

    const districtMap: Record<string, string> = {};
    uniqueDistricts.forEach((d, i) => (districtMap[d] = `District ${i + 1}`));

    return response.map((item) => ({
      dateIndex: (uniqueDates.indexOf(item[1]) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      date: item[1],
      month: getMonthFromDate(item[1]),
      block: item[2],
      area: areaMap[item[3]] || item[3],
      mw: item[4],
      lu: item[4] / 400,
      discom: discomMap[item[5]] || item[5],
      division: divisionMap[item[6]] || item[6],
      district: districtMap[item[7]] || item[7],
      mwh: 0,
    }));
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getRajasthanAreaForecastData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<RajasthanDiscomDrawal[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanAreaForecastData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    console.log("====================================");
    console.log(response);
    return response.map((item) => {
      return {
        date: item[1],
        month: getMonthFromDate(item[1]),
        block: item[2],
        area: item[3],
        mw: item[4],
        discom: item[5],
        division: item[6],
        district: item[7],
        mwh: 0,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getRajasthanDiscomData(
  startDate: string,
  endDate: string
): Promise<RajasthanDiscomData[]> {
  try {
    const response: Promise<RajasthanDiscomData[]> = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const data = await response;
    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return (await response).map((item) => {
      return {
        ...item,
        drawal_mwh: item.drawal_mw / 4,
        drawal_mw: item.drawal_mw,
        drawal_lu: item.drawal_mw / 400,
        total_mwh: (item.load_shedding_mw + item.drawal_mw) / 4,
        total_mw: item.load_shedding_mw + item.drawal_mw,
        schedule_mw: item.schedule_mw,
        schedule_mwh: item.schedule_mw / 4,
        schedule_lu: item.schedule_mw / 400,
        load_shedding_mwh: item.load_shedding_mw / 4,
        load_shedding_lu: item.load_shedding_mw / 400,
        dateIndex:
          (
            uniqueDates.indexOf((item as { date: string }).date) + 1
          ).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getDemoRajasthanDiscomData(
  startDate: string,
  endDate: string
): Promise<RajasthanDiscomData[]> {
  try {
    const response: Promise<RajasthanDiscomData[]> = await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanDiscomData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const data = await response;
    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));

    // Map discom codes to demo names
    const discomMap: Record<string, string> = {
      JDVVNL: "Discom 1",
      JVVNL: "Discom 2",
      AVVNL: "Discom 3",
    };

    return (await response).map((item) => {
      return {
        ...item,
        discom: discomMap[item.discom] || item.discom, // Apply the mapping
        drawal_mwh: item.drawal_mw / 4,
        drawal_mw: item.drawal_mw,
        drawal_lu: item.drawal_mw / 400,
        total_mwh: (item.load_shedding_mw + item.drawal_mw) / 4,
        total_mw: item.load_shedding_mw + item.drawal_mw,
        schedule_mw: item.schedule_mw,
        schedule_mwh: item.schedule_mw / 4,
        schedule_lu: item.schedule_mw / 400,
        load_shedding_mwh: item.load_shedding_mw / 4,
        load_shedding_lu: item.load_shedding_mw / 400,
        dateIndex:
          (
            uniqueDates.indexOf((item as { date: string }).date) + 1
          ).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getRajasthanForecastDiscomData(
  startDate: string,
  endDate: string,
  model: string
): Promise<RajasthanDiscomData[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getDiscomForecast?start_date=${startDate}&end_date=${endDate}&model=${model}`,
      method: HttpMethod.GET,
    });
    const data = await response;
    const uniqueDates = Array.from(
      new Set(data.map((item: { date: any }) => item.date))
    );
    return (await response).map((item: RajasthanDiscomData) => {
      return {
        ...item,
        discom: item.discom,
        drawal_mwh: (item.drawal_mw + 0) / 4,
        drawal_mw: item.drawal_mw + 0,
        drawal_lu: (item.drawal_mw + 0) / 400,
        total_mwh: item.drawal_mw / 4,
        total_mw: item.drawal_mw,
        total_lu: item.drawal_mw / 400,
        schedule_mwh: item.schedule_mw / 4,
        schedule_mw: item.schedule_mw,
        schedule_lu: item.schedule_mw / 400,
        load_shedding_mwh: 0,
        load_shedding_lu: 0,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

function applyBlockReplacements(
  data: RajasthanDiscomData[]
): RajasthanDiscomData[] {
  const replacementMappings: {
    targetDate: string;
    discom: string;
    blocks: number[];
    sourceDate: string;
  }[] = [
    {
      targetDate: "2024-12-10",
      discom: "Jodhpur",
      blocks: [82],
      sourceDate: "2024-12-09",
    },
    {
      targetDate: "2024-12-10",
      discom: "Ajmer",
      blocks: [82],
      sourceDate: "2024-12-09",
    },
  ];

  const modifiedData = [...data]; // Create a copy to avoid modifying original data

  replacementMappings.forEach(({ targetDate, discom, blocks, sourceDate }) => {
    blocks.forEach((block) => {
      const sourceRecord = data.find(
        (record) =>
          record.date === sourceDate &&
          record.block === block &&
          record.discom === discom
      );

      if (sourceRecord) {
        modifiedData.forEach((record) => {
          if (
            record.date === targetDate &&
            record.block === block &&
            record.discom === discom
          ) {
            record.schedule_mw = sourceRecord.schedule_mw; // Apply the replacement
          }
        });
      }
    });
  });

  return modifiedData;
}

export async function getRajasthanGenerationData(
  startDate: string,
  endDate: string
): Promise<RajasthanGenData[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getGenerationData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const uniqueDates = Array.from(
      new Set(response.map((item: any[]) => item[0]))
    );
    return response.map((item: any[]) => {
      const convertedData = convertToRajasthanGenData(item);
      return {
        ...convertedData,
        dateIndex:
          (uniqueDates.indexOf(convertedData.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Generation data:", error);
    return [];
  }
}

export async function getDemoRajasthanGenerationData(
  startDate: string,
  endDate: string
): Promise<RajasthanGenData[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getGenerationData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    // derive unique dates & stations
    const uniqueDates = Array.from(
      new Set(response.map((item: any[]) => item[0]))
    );
    const uniqueStations = Array.from(
      new Set(
        response.map((item: any[]) => convertToRajasthanGenData(item).station)
      )
    );
    const stationMap: Record<string, string> = {};
    uniqueStations.forEach(
      (st, i) => (stationMap[st as string] = `Station ${i + 1}`)
    );

    return response.map((item: any[]) => {
      const convertedData = convertToRajasthanGenData(item);
      return {
        ...convertedData,
        state: "Demo State",
        station: stationMap[convertedData.station] || convertedData.station,
        dateIndex:
          (uniqueDates.indexOf(convertedData.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Generation data:", error);
    return [];
  }
}

export async function getRajasthanIsgsData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanIsgs[]> {
  try {
    const response = (await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanIsgsData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    })) as RajasthanIsgs[];

    const uniqueDates = Array.from(new Set(response.map((item) => item.date)));
    return response.map((item) => {
      return {
        ...item,
        value_mwh: item.value_mw / 4,
        station: item.from_utility__name,
        month: getMonthFromDate(item.date),
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        from_gen__generation_source: item.generator_source,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan ISGS Data:", error);
    return [];
  }
}

export async function getDemoRajasthanIsgsData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanIsgs[]> {
  try {
    const response = (await buildHttpResponse({
      endPoint: `rajasthan/getRajasthanIsgsData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    })) as RajasthanIsgs[];

    // derive unique dates, states & stations
    const uniqueDates = Array.from(new Set(response.map((item) => item.date)));
    const uniqueStates: string[] = Array.from(
      new Set(response.map((item: any) => item.state))
    );
    const uniqueStations = Array.from(
      new Set(response.map((item) => item.from_utility__name))
    );

    // build generic maps
    const stateMap: Record<string, string> = {};
    uniqueStates.forEach((s, i) => (stateMap[s] = `State ${i + 1}`));

    const stationMap: Record<string, string> = {};
    uniqueStations.forEach((s, i) => (stationMap[s] = `Station ${i + 1}`));

    return response.map((item) => ({
      ...item,
      state: stateMap[item.state] || item.state,
      station: stationMap[item.from_utility__name] || item.from_utility__name,
      from_utility__name:
        stationMap[item.from_utility__name] || item.from_utility__name,
      value_mwh: item.value_mw / 4,
      month: getMonthFromDate(item.date),
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      from_gen__generation_source: item.generator_source,
    }));
  } catch (error) {
    console.error("Error fetching Rajasthan ISGS Data:", error);
    return [];
  }
}

export async function getRajasthanIsgsIntervalData({
  startDate,
  endDate,
  interval = "date",
}: {
  startDate: string;
  endDate: string;
  interval?: string;
}): Promise<RajasthanIsgs[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/isgs-data-interval?start_date=${startDate}&end_date=${endDate}&interval=${interval}`,
      method: HttpMethod.GET,
    });
    // const mappings: RajMappings = await buildHttpResponse({
    //   endPoint: "rajasthan/getMappings",
    //   method: HttpMethod.GET,
    // });

    // Calculate uniqueDates from the response
    const uniqueDates = Array.from(
      new Set(response.map((item: any) => item.date))
    );

    return response.map((item: any) => {
      return {
        ...item,
        from_gen__generation_source: item.generator_source,
        from_state: item.state,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Interval ISGS Data:", error);
    return [];
  }
}

export async function getDemoRajasthanIsgsIntervalData({
  startDate,
  endDate,
  interval = "date",
}: {
  startDate: string;
  endDate: string;
  interval?: string;
}): Promise<RajasthanIsgs[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/isgs-data-interval?start_date=${startDate}&end_date=${endDate}&interval=${interval}`,
      method: HttpMethod.GET,
    });

    // calculate uniques
    const uniqueDates = Array.from(
      new Set(response.map((item: any) => item.date))
    );
    const uniqueStates: string[] = Array.from(
      new Set(response.map((item: any) => item.state))
    );

    // derive unique station names and build a generic map
    const uniqueStations: string[] = Array.from(
      new Set(response.map((item: any) => item.from_utility__name))
    );
    const stationMap: Record<string, string> = {};
    uniqueStations.forEach((st, i) => {
      stationMap[st] = `Station ${i + 1}`;
    });

    // build state map
    const stateMap: Record<string, string> = {};
    uniqueStates.forEach((s, i) => {
      stateMap[s] = `State ${i + 1}`;
    });

    return response.map((item: any) => {
      return {
        ...item,
        state: stateMap[item.state] || item.state,
        from_state: stateMap[item.state] || item.state,
        station: stationMap[item.from_utility__name] || item.from_utility__name,
        from_utility__name:
          stationMap[item.from_utility__name] || item.from_utility__name,
        from_gen__generation_source: item.generator_source,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Interval ISGS Data:", error);
    return [];
  }
}

export async function getRajasthanCollectiveData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanCollective[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getCollectiveData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching Rajasthan Collective Data:", error);
    return [];
  }
}

export async function getGnaTgnaData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanGnaTgna[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getGnaTgnaData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    return response.map((item: { slot: any }) => {
      return {
        ...item,
        time_block: item.slot,
      };
    });
  } catch (error) {
    console.error("Error fetching GnaTgna data:", error);
    return [];
  }
}

export async function getDemoGnaTgnaData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanGnaTgna[]> {
  try {
    const response: any[] = await buildHttpResponse({
      endPoint: `rajasthan/getGnaTgnaData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    // derive uniques for each field
    const uniqueFromStates = Array.from(
      new Set(response.map((item) => item.from_state__name))
    );
    const uniqueFromEntityStates = Array.from(
      new Set(response.map((item) => item.from_utility__entity_state__name))
    );
    const uniqueFromUtilities = Array.from(
      new Set(response.map((item) => item.from_utility__name))
    );
    const uniqueToStates = Array.from(
      new Set(response.map((item) => item.to_state__name))
    );
    const uniqueToUtilities = Array.from(
      new Set(response.map((item) => item.to_utility__name))
    );
    const uniqueTraders = Array.from(
      new Set(response.map((item) => item.trader__name))
    );

    // build generic maps
    const fromStateMap: Record<string, string> = {};
    uniqueFromStates.forEach((v, i) => {
      fromStateMap[v] = `State ${i + 1}`;
    });

    const fromEntityStateMap: Record<string, string> = {};
    uniqueFromEntityStates.forEach((v, i) => {
      fromEntityStateMap[v] = `State ${i + 1}`;
    });

    const fromUtilityMap: Record<string, string> = {};
    uniqueFromUtilities.forEach((v, i) => {
      fromUtilityMap[v] = `Utility ${i + 1}`;
    });

    const toStateMap: Record<string, string> = {};
    uniqueToStates.forEach((v, i) => {
      toStateMap[v] = `State ${i + 1}`;
    });

    const toUtilityMap: Record<string, string> = {};
    uniqueToUtilities.forEach((v, i) => {
      toUtilityMap[v] = `Utility ${i + 1}`;
    });

    const traderMap: Record<string, string> = {};
    uniqueTraders.forEach((v, i) => {
      traderMap[v] = `Trader ${i + 1}`;
    });

    return response.map((item) => ({
      ...item,
      time_block: item.slot,
      from_state__name:
        fromStateMap[item.from_state__name] || item.from_state__name,
      from_utility__entity_state__name:
        fromEntityStateMap[item.from_utility__entity_state__name] ||
        item.from_utility__entity_state__name,
      from_utility__name:
        fromUtilityMap[item.from_utility__name] || item.from_utility__name,
      to_state__name: toStateMap[item.to_state__name] || item.to_state__name,
      to_utility__name:
        toUtilityMap[item.to_utility__name] || item.to_utility__name,
      trader__name: traderMap[item.trader__name] || item.trader__name,
    }));
  } catch (error) {
    console.error("Error fetching GnaTgna data:", error);
    return [];
  }
}
export async function createRajProcurementRecord(
  formData: any
): Promise<string> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/procurement/create`,
      method: HttpMethod.POST,
      body: formData,
    });
    return response.message;
  } catch (error) {
    console.error("Error fetching GnaTgna data:", error);
    return "Inserting error";
  }
}

export async function getRajFileTypes(): Promise<string[]> {
  const response = await buildHttpResponse({
    endPoint: "rajasthan/get-file-types",
    method: HttpMethod.GET,
  });
  return response;
}

export async function uploadRajFile(formData: any): Promise<string> {
  const response = await buildMultipartHttpResponse({
    endPoint: "rajasthan/upload-file", // Replace with your endpoint
    method: HttpMethod.POST,
    formData,
  });
  return response.message;
}

export async function getRajReData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<ReEnergyData[]> {
  const response: ReEnergyData[] = await buildHttpResponse({
    endPoint: `rajasthan/getRenewableGeneration?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });

  const uniqueDates = Array.from(new Set(response.map((item) => item.date)));
  return response.map((item) => {
    return {
      ...item,
      value_mwh: item.value_mw / 4,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: getMonthFromDate(item.date),
      energy_type: item.energy_type__name,
      time_block: item.slot,
    };
  });
}
export async function getProcurementRecord(
  page: any,
  perpage: any
): Promise<RajProcurementRecord[]> {
  try {
    const response = await fetch(
      `https://datahub.gna.energy/rajasthan_procurement?page=${page}&per_page=${perpage}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching Procurement Record :", error);
    return [];
  }
}

export async function getRajOperatingPar(): Promise<RajGenParams[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getRajOperatingPar`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching Rajasthan Operating Parameters data:", error);
    return [];
  }
}

export async function getRajOutageData(startDate: string, endDate: string) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getMachinePositionDetailed?from_date=${startDate}&to_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getDemoRajOperatingPar(): Promise<RajGenParams[]> {
  try {
    const response = (await buildHttpResponse({
      endPoint: `rajasthan/getRajOperatingPar`,
      method: HttpMethod.GET,
    })) as RajGenParams[];

    // derive uniques
    const uniqueGenerators = Array.from(
      new Set(response.map((item) => item.generator))
    );

    // build generic map
    const generatorMap: Record<string, string> = {};
    uniqueGenerators.forEach((g, i) => {
      generatorMap[g] = `Generator ${i + 1}`;
    });

    // apply mapping
    return response.map((item) => ({
      ...item,
      generator: generatorMap[item.generator] || item.generator,
    }));
  } catch (error) {
    console.error("Error fetching Rajasthan Operating Parameters data:", error);
    return [];
  }
}

export async function getRajFiles(): Promise<RajasthanUploadFile[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getRajUploadedFile`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching Rajasthan Files data:", error);
    return [];
  }
}

export async function rajChatGptRes({
  query,
  thread_token,
}: {
  query: string;
  thread_token: string;
}): Promise<{ sender: String; content: String }> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/handeUserQuery?query=${query}&thread_token=${thread_token}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajGenProfileData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajGenProfile[]> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getGenProfileData?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}
export async function getRajSurplusData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajSurplusDeficitData[]> {
  const response = await buildHttpResponse({
    endPoint: `/rajasthan/getSurDefProfile?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response.map((item: any) => {
    return {
      ...item,
      block: item.time_block,
    };
  });
}

export async function getSurDefProfile({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajGenProfile[]> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getSurDefProfile?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajDeep({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajProcurement[]> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getRajDeep?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajIntraGen({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajProcurement[]> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getRajIntraGen?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajIsgs({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajProcurement[]> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getRajIsgs?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajTamData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajTamData[]> {
  const response: RajTamData[] = await buildHttpResponse({
    endPoint: `rajasthan/getRajNoarData?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajNoar({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajTamData[]> {
  const response: RajTamData[] = await buildHttpResponse({
    endPoint: `rajasthan/getRajNoarData?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajBankingData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajBankingData[]> {
  const response: RajBankingData[] = await buildHttpResponse({
    endPoint: `rajasthan/getRajBankingData?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response.map((item) => {
    return {
      ...item,
      mwh: item.mwh,
    };
  });
}

export async function getRajEntity() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/entities`,
    method: HttpMethod.GET,
  });
  return response;
}
export async function getRajTrader() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/traders`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getDemoRajEntity() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/entities`,
    method: HttpMethod.GET,
  });
  return response;
}
export async function getDemoRajTrader() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/traders`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function PostRajTransaction(data: any) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/transactions/create/`,
    method: HttpMethod.POST,
    body: data,
  });
  return response;
}
export async function PostBulkRajTransaction(data: any) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/transaction/bulk_create`,
    method: HttpMethod.POST,
    body: data,
  });
  return response;
}
export async function getRajTransaction() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/transactions/`,
    method: HttpMethod.GET,
  });
  return response;
}
export async function deleteRajTransaction(transaction_id: number) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/transactions/${transaction_id}/delete/`,
    method: HttpMethod.DELETE,
  });
  return response;
}
export async function upadteRajTransaction(transaction_id: number, data: any) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/transactions/${transaction_id}/update/`,
    method: HttpMethod.PUT,
    body: data,
  });
  return response;
}

export async function getRajSchedulingData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getRajSchedulingData?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getRajasthanOutageData(
  startDate: string,
  endDate: string,
  interval = "date"
) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getMachinePositionInterval?start_date=${startDate}&end_date=${endDate}&interval=${interval}`,
    method: HttpMethod.GET,
  });

  // Get unique dates from the response
  const uniqueDates = Array.from(
    new Set(response.map((item: any) => item.date))
  );

  return response.map((item: any) => {
    return {
      ...item,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      outage_date: item.date,
      outage_time: item.slot,
    };
  });
}

export async function getDemoRajasthanOutageData(
  startDate: string,
  endDate: string,
  interval = "date"
) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/getMachinePositionInterval?start_date=${startDate}&end_date=${endDate}&interval=${interval}`,
    method: HttpMethod.GET,
  });

  // Get unique dates from the response
  const uniqueDates = Array.from(
    new Set(response.map((item: any) => item.date))
  );

  // derive unique station names and build a generic map
  const uniqueStations: string[] = Array.from(
    new Set<string>(response.map((item: any) => item.station_name as string))
  );
  const stationMap: Record<string, string> = {};
  uniqueStations.forEach((s, i) => {
    stationMap[s] = `Station ${i + 1}`;
  });

  return response.map((item: any) => {
    return {
      ...item,
      // apply station_name mapping
      station_name: stationMap[item.station_name] || item.station_name,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      outage_date: item.date,
      outage_time: item.slot,
    };
  });
}

export async function fetchRvpnData(
  startdate: string,
  endDate: string
): Promise<RajashtanRrvpn[]> {
  const response: Promise<RajashtanRrvpn[]> = await buildHttpResponse({
    endPoint: `rajasthan/getRajasthanNreb?start_date=${startdate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  const data = await response;
  const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
  return data.map((item) => {
    return {
      ...item,
      dateIndex:
        (uniqueDates.indexOf((item as { date: string }).date) + 1).toString() +
        " Day",
    };
  });
}

// MOD START POST Session
// MOD Ruvital START POST Session
export async function fetchgetModRuvnlSession(startdate: string) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/startSession?date=${startdate}`,
    method: HttpMethod.POST,
    body: {
      date: startdate,
    },
  });
  return response;
}
export async function getModRuvnlSession() {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSession`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD Stage data
export async function ModRuvnlStagePost(stage: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postStage`,
    method: HttpMethod.POST,
    body: {
      stage: stage,
      session: session,
    },
  });
  return response;
}
export async function fetchModRuvnlArchive(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getPreviousSession?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function ModRuvnlActivateSession(session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/activateSession`,
    method: HttpMethod.POST,
    body: {
      session: session,
    },
    noCache: true,
  });
  return response;
}
// MOD DAM default data
export async function fetchModRuvnlDamDefault(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getDefaultData/dam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function ModRuvnlAggregatedLoadData(
  ModAggregatedData: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postAggregatedLoadPrice`,
    method: HttpMethod.POST,
    body: ModAggregatedData,
  });

  return response as ApiResponse;
}

// MOD RTM default data
export async function fetchModRuvnlRtmDefault(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getDefaultData/rtm?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
  });
  return response;
}
export async function fetchModRuvnlGDamData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getData/gdam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function ModRuvnlGDamData(ModGDamdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postGDam`,
    method: HttpMethod.POST,
    noCache: true,
    body: ModGDamdata,
  });

  return response as ApiResponse;
}
export async function fetchModRuvnlGDamDefault(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getDefaultData/gdam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchModRuvnlDemandDefault(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getDemandDefault?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
  });
  return response;
}
// upload file POST DAM RTM DEMAND
export async function ModRuvnlDamData(ModDamdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postDam`,
    method: HttpMethod.POST,
    body: ModDamdata,
  });

  return response as ApiResponse;
}

export async function ModRuvnlRtmData(ModRtmdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postRtm`,
    method: HttpMethod.POST,
    body: ModRtmdata,
  });

  return response as ApiResponse;
}
export async function ModRuvnlDemandData(
  ModDemanddata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postDemand`,
    method: HttpMethod.POST,
    body: ModDemanddata,
  });

  return response as ApiResponse;
}

// MOD DAM fetch Data
export async function fetchModRuvnlDamData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getData/dam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModRuvnlDemandData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getDemand?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD RTM fetch Data
export async function fetchModRuvnlRtmData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getData/rtm?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function ModRuvnlBulkUploadFile(formData: any): Promise<{
  automationMod_files: Array<{ file_url: string }>;
}> {
  const response = await buildMultipartHttpResponse({
    endPoint: "mod_ruvnl/automation",
    method: HttpMethod.POST,
    formData,
  });
  return response;
}

export async function CreateBidRuvnlTable(
  ModUpdatedata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/createBid`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}
export async function fetchModRuvnlTableChartData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getMODChart?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModRuvnlTableData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getMOD?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function ModRuvnlUpdateData(
  ModUpdatedata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postMOD`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}
export async function ModRuvnlUpdateBidData(
  ModUpdatedata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/postBid`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}

export async function fetchModRuvnlBidTableData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getBid?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModRuvnlBidDownload(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getBidDownload?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as ApiResponse;
}

export async function fetchModRuvnlSimulationSummary(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSimulatorGenChart?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModRuvnlSimulationTopBuyer(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSimulatorGenPrice?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModRuvnlSimulationCostPower(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSimulatorCostPower?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchModRuvnlSimulationSaleRevenue(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSimulatorSalesRevenue?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function getModRuvnlBidSimulationData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/getSimulatorBid?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// GNA/TGNA Optimizer Session

export async function fetchOptimizerSession(
  startDate: string,
  endDate: string
) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/start-gna-session?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.POST,
    body: {
      start_date: startDate,
      end_date: endDate,
    },
  });
  return response;
}
export async function getGNAOptimizerSession() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/get-gna-session`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchOptimizerSummary() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/generation-profile-slotwise`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimalUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-optimal-utilisation-slotwise`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchSimulatedUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-simulated-utilisation-slotwise`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimizerMetrics() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-utilisation-metrics`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimizerStatistics() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-utilisation-statistics`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimizerGeneration() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/generation-profile-cummulative`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimizerSguGeneration() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/generation-profile`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function OptimizerSguUpdateData(
  Updatedata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/generation-profile`,
    method: HttpMethod.POST,
    body: Updatedata,
  });

  return response as ApiResponse;
}
export async function OptimizerCurrentUpdateData(
  Updatedata: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-parameters`,
    method: HttpMethod.POST,
    body: Updatedata,
  });

  return response as ApiResponse;
}

export async function fetchOptimizerCurrentOptimisation() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-parameters`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchDailyOptimalUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-optimal-utilisation-daily`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchDailysimulatedUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-simulated-utilisation-daily`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchMonthlysimulatedUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-simulated-utilisation-monthly`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function OptimizerGnaProceed() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-proceed`,
    method: HttpMethod.POST,
  });

  return response as ApiResponse;
}

export async function fetchRuvnlLgbrTableData(
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/get-lgbr?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchRuvnlLgbrGetData(
  type: string | null,
  time_slot: number | null,
  startdate: string,
  session: number
) {
  const response = await buildHttpResponse({
    endPoint: `mod_ruvnl/get-lgbr-generator?date=${startdate}&session=${session}&type=${type}&time_slot=${time_slot}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchMonthlyOptimalUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/gna-optimal-utilisation-monthly`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function getRajasthanGssRestrictedAreaSummaryMetrics(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    console.log(`[AREA API] Calling endpoint with dates: ${startDate} to ${endDate}`);
    
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `rajasthan/gss-load-slot-wise-metrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    
    console.log(`[AREA API] Response received:`, res.length, "items");

    if (!res || res.length === 0) {
      console.warn("[AREA API] No data returned from API");
      return [];
    }

    const mappedData = res.map((item: any) => {
      return {
        slot: item.slot,
        discom: item.discom,
        station: item.station,
        district: item.district,
        time_string: item.time_string,
        min_load: parseFloat(item.min_load?.toString() || "0"),
        date_of_min_load: item.date_of_min_load,
        max_load: parseFloat(item.max_load?.toString() || "0"),
        date_of_max_load: item.date_of_max_load,
        avg_load: parseFloat(item.avg_load?.toString() || "0"),
        mode_load: parseFloat(item.mode_load?.toString() || "0"),
        mode_load_class_dynamic: parseFloat(item.mode_load_class_dynamic?.toString() || "0"),
        mode_load_class_static: parseFloat(item.mode_load_class_static?.toString() || "0"),
        mode_load_formula: parseFloat(item.mode_load_formula?.toString() || "0"),
        mode_load_window_formula: parseFloat(item.mode_load_window_formula?.toString() || "0"),
      };
    });

    console.log(`[AREA API] Mapped ${mappedData.length} items successfully`);
    return mappedData;
  } catch (error) {
    console.error("[AREA API] Error fetching data:", error);
    
    if (error instanceof Error) {
      console.error("[AREA API] Error message:", error.message);
      console.error("[AREA API] Error stack:", error.stack);
    }
    
    return [];
  }
}
export async function getRajasthanGssRestrictedSummaryMetricsTotal(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {    
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `rajasthan/gss-load-slot-wise-metrics-total?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
        
    if (!res || res.length === 0) {
      return [];
    }
    
    if (res.length > 0) {
    }

    const mappedData = res.map((item: any) => {
      return {
        slot: item.slot,
        time_string: item.time_string,
        min_load: parseFloat(item.min_load?.toString() || "0"),
        date_of_min_load: item.date_of_min_load,
        max_load: parseFloat(item.max_load?.toString() || "0"),
        date_of_max_load: item.date_of_max_load,
        avg_load: parseFloat(item.avg_load?.toString() || "0"),
        mode_load: parseFloat(item.mode_load?.toString() || "0"),
        mode_load_class_dynamic: parseFloat(item.mode_load_class_dynamic?.toString() || "0"),
        mode_load_class_static: parseFloat(item.mode_load_class_static?.toString() || "0"),
        mode_load_formula: parseFloat(item.mode_load_formula?.toString() || "0"),
        mode_load_window_formula: parseFloat(item.mode_load_window_formula?.toString() || "0"),
      };
    });
        return mappedData;
    
  } catch (error) {
    console.error("[TOTAL API] Error fetching data:", error);
    
    if (error instanceof Error) {
      console.error("[TOTAL API] Error message:", error.message);
      console.error("[TOTAL API] Error stack:", error.stack);
    }
    
    return [];
  }
}
// Discom API - Returns discom-level aggregated data
export async function getRajasthanGssRestrictedSummaryMetricsDiscom(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `rajasthan/gss-load-slot-wise-metrics-discom?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    
    if (!res || res.length === 0) {
      return [];
    }
    
    if (res.length > 0) {
    }

    const mappedData = res.map((item: any) => {
      return {
        slot: item.slot,
        discom: item.discom,
        time_string: item.time_string,
        min_load: parseFloat(item.min_load?.toString() || "0"),
        date_of_min_load: item.date_of_min_load,
        max_load: parseFloat(item.max_load?.toString() || "0"),
        date_of_max_load: item.date_of_max_load,
        avg_load: parseFloat(item.avg_load?.toString() || "0"),
        mode_load: parseFloat(item.mode_load?.toString() || "0"),
        mode_load_class_dynamic: parseFloat(item.mode_load_class_dynamic?.toString() || "0"),
        mode_load_class_static: parseFloat(item.mode_load_class_static?.toString() || "0"),
        mode_load_formula: parseFloat(item.mode_load_formula?.toString() || "0"),
        mode_load_window_formula: parseFloat(item.mode_load_window_formula?.toString() || "0"),
      };
    });
    return mappedData;
    
  } catch (error) {
    console.error("[DISCOM API] Error fetching data:", error);
    
    if (error instanceof Error) {
      console.error("[DISCOM API] Error message:", error.message);
      console.error("[DISCOM API] Error stack:", error.stack);
    }
    
    return [];
  }
}

// District API - Returns district-wise data (discom + district)
export async function getRajasthanGssLoadMetricsRestrictedDiscomDistrict(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    console.log(`[DISTRICT API] Calling endpoint with dates: ${startDate} to ${endDate}`);
    
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `rajasthan/gss-load-metrics-discom-district?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    
    console.log(`[DISTRICT API] Response received:`, res.length, "items");

    if (!res || res.length === 0) {
      console.warn("[DISTRICT API] No data returned from API");
      return [];
    }

    const mappedData = res.map((item: any) => {
      return {
        slot: item.slot,
        discom: item.discom,
        district: item.district,
        time_string: item.time_string,
        min_load: parseFloat(item.min_load?.toString() || "0"),
        date_of_min_load: item.date_of_min_load,
        max_load: parseFloat(item.max_load?.toString() || "0"),
        date_of_max_load: item.date_of_max_load,
        avg_load: parseFloat(item.avg_load?.toString() || "0"),
        mode_load: parseFloat(item.mode_load?.toString() || "0"),
        mode_load_class_dynamic: parseFloat(item.mode_load_class_dynamic?.toString() || "0"),
        mode_load_class_static: parseFloat(item.mode_load_class_static?.toString() || "0"),
        mode_load_formula: parseFloat(item.mode_load_formula?.toString() || "0"),
        mode_load_window_formula: parseFloat(item.mode_load_window_formula?.toString() || "0"),
      };
    });

    console.log(`[DISTRICT API] Mapped ${mappedData.length} items successfully`);
    return mappedData;
    
  } catch (error) {
    console.error("[DISTRICT API] Error fetching data:", error);
    
    if (error instanceof Error) {
      console.error("[DISTRICT API] Error message:", error.message);
      console.error("[DISTRICT API] Error stack:", error.stack);
    }
    
    return [];
  }
}
export async function getRajasthanDemandMetrics(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `rajasthan/getDemandMetrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;

    return res.map((item: any) => {
      return {
        slot: item.slot,
        time_string: item.time_string,
        min_demand: parseFloat(item.min_demand.toString()),
        max_demand: parseFloat(item.max_demand.toString()),
        avg_demand: parseFloat(item.avg_demand.toString()),
        mode_demand_window_formula: parseFloat(
          item.mode_demand_window_formula.toString()
        ),
        date_of_min: item.date_of_min,
        date_of_max: item.date_of_max,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Demand Metrics data:", error);
    return [];
  }
}
export async function getDiscomDrawalScheduleMetrics(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `rajasthan/getDiscomDrawalScheduleMetrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;

    return res.map((item: any) => {
      return {
        slot: item.slot,
        discom: item.discom,
        time_string: item.time_string,
        avg_drawal: parseFloat(item.avg_drawal?.toString() || "0"),
        avg_schedule: parseFloat(item.avg_schedule?.toString() || "0"),
        date_of_max_drawal: item.date_of_max_drawal,
        date_of_max_schedule: item.date_of_max_schedule,
        date_of_min_drawal: item.date_of_min_drawal,
        date_of_min_schedule: item.date_of_min_schedule,
        max_drawal: parseFloat(item.max_drawal?.toString() || "0"),
        max_schedule: parseFloat(item.max_schedule?.toString() || "0"),
        min_drawal: parseFloat(item.min_drawal?.toString() || "0"),
        min_schedule: parseFloat(item.min_schedule?.toString() || "0"),
        mode_drawal: parseFloat(item.mode_drawal?.toString() || "0"),
        mode_drawal_class_dynamic: parseFloat(
          item.mode_drawal_class_dynamic?.toString() || "0"
        ),
        mode_drawal_class_static: parseFloat(
          item.mode_drawal_class_static?.toString() || "0"
        ),
        mode_drawal_formula: parseFloat(
          item.mode_drawal_formula?.toString() || "0"
        ),
        mode_drawal_window_formula: parseFloat(
          item.mode_drawal_window_formula?.toString() || "0"
        ),
        mode_schedule: parseFloat(item.mode_schedule?.toString() || "0"),
        mode_schedule_class_dynamic: parseFloat(
          item.mode_schedule_class_dynamic?.toString() || "0"
        ),
        mode_schedule_class_static: parseFloat(
          item.mode_schedule_class_static?.toString() || "0"
        ),
        mode_schedule_formula: parseFloat(
          item.mode_schedule_formula?.toString() || "0"
        ),
        mode_schedule_window_formula: parseFloat(
          item.mode_schedule_window_formula?.toString() || "0"
        ),
      };
    });
  } catch (error) {
    console.error("Error fetching Discom Drawal Schedule Metrics data:", error);
    return [];
  }
}

export async function getRajasthanDailyPeak(
  startDate: string,
  endDate: string
): Promise<HarayanaDailyPeakData[]> {
  try {
    const response: Promise<{ data: HarayanaDailyPeakData[] }> =
      await buildHttpResponse({
        endPoint: `rajasthan/getDailyPeakDemand?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        peak_mw: parseFloat(item.daily_peak_demand_value_mw.toString()),
        average_mw: parseFloat(item.avg_daily_peak_demand_value_mw.toString()),
        evening_peak_mw: parseFloat(
          item.formatted_data[0].max_demand.toString()
        ),
        evening_peak_slot: item.formatted_data[0].max_demand_slot,
        morning_peak_mw: parseFloat(
          item.formatted_data[1].max_demand.toString()
        ),
        morning_peak_slot: item.formatted_data[1].max_demand_slot,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}
export async function getDailyDiscomDrawalSchedule(
  startDate: string,
  endDate: string
): Promise<DailyDiscomDrawalSchedule[]> {
  try {
    const response: Promise<{ data: DailyDiscomDrawalSchedule[] }> =
      await buildHttpResponse({
        endPoint: `rajasthan/getDailyDiscomDrawalSchedule?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        date: item.date,
        daily_peak_drawal_mw: parseFloat(item.daily_peak_drawal_mw.toString()),
        avg_daily_drawal_mw: item.avg_daily_drawal_mw,
        daily_peak_schedule_mw: parseFloat(
          item.daily_peak_schedule_mw.toString()
        ),
        avg_daily_schedule_mw: item.avg_daily_schedule_mw,
        // Evening peak values
        evening_peak_drawal_mw: parseFloat(
          item.formatted_data[0].max_drawal.toString()
        ),
        evening_peak_drawal_slot: item.formatted_data[0].max_drawal_slot,
        evening_peak_schedule_mw: parseFloat(
          item.formatted_data[0].max_schedule.toString()
        ),
        evening_peak_schedule_slot: item.formatted_data[0].max_schedule_slot,
        // Morning peak values
        morning_peak_drawal_mw: parseFloat(
          item.formatted_data[1].max_drawal.toString()
        ),
        morning_peak_drawal_slot: item.formatted_data[1].max_drawal_slot,
        morning_peak_schedule_mw: parseFloat(
          item.formatted_data[1].max_schedule.toString()
        ),
        morning_peak_schedule_slot: item.formatted_data[1].max_schedule_slot,
        formatted_data: [
          {
            time_period: item.formatted_data[0].time_period,
            max_schedule: parseFloat(
              item.formatted_data[0].max_schedule.toString()
            ),
            max_drawal: parseFloat(
              item.formatted_data[0].max_drawal.toString()
            ),
            min_schedule: parseFloat(
              item.formatted_data[0].min_schedule.toString()
            ),
            min_drawal: parseFloat(
              item.formatted_data[0].min_drawal.toString()
            ),
            avg_schedule: parseFloat(
              item.formatted_data[0].avg_schedule.toString()
            ),
            avg_drawal: parseFloat(
              item.formatted_data[0].avg_drawal.toString()
            ),
            max_schedule_slot: item.formatted_data[0].max_schedule_slot,
            max_drawal_slot: item.formatted_data[0].max_drawal_slot,
            min_schedule_slot: item.formatted_data[0].min_schedule_slot,
            min_drawal_slot: item.formatted_data[0].min_drawal_slot,
          },
          {
            time_period: item.formatted_data[1].time_period,
            max_schedule: parseFloat(
              item.formatted_data[1].max_schedule.toString()
            ),
            max_drawal: parseFloat(
              item.formatted_data[1].max_drawal.toString()
            ),
            min_schedule: parseFloat(
              item.formatted_data[1].min_schedule.toString()
            ),
            min_drawal: parseFloat(
              item.formatted_data[1].min_drawal.toString()
            ),
            avg_schedule: parseFloat(
              item.formatted_data[1].avg_schedule.toString()
            ),
            avg_drawal: parseFloat(
              item.formatted_data[1].avg_drawal.toString()
            ),
            max_schedule_slot: item.formatted_data[1].max_schedule_slot,
            max_drawal_slot: item.formatted_data[1].max_drawal_slot,
            min_schedule_slot: item.formatted_data[1].min_schedule_slot,
            min_drawal_slot: item.formatted_data[1].min_drawal_slot,
          },
        ],
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

  export async function getRestrictedGssLoadDailyDiscom(
    startDate: string,
    endDate: string
  ): Promise<any[]> {
    try {
      const response = (await buildHttpResponse({
        endPoint: `rajasthan/gss-load-daily-discom?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      })) as any;

      const data: any[] = response.data;

      // Pre-compute unique dates once
      const uniqueDates = [...new Set(data.map((item) => item.date))];
      const dateIndexMap = new Map(
        uniqueDates.map((date, idx) => [date, `${idx + 1} Day`])
      );
      const dateRange = `${startDate} to ${endDate}`;

      // Use a more efficient mapping approach
      return data.map((item) => {
        const eveningData = item.formatted_data[0];
        const morningData = item.formatted_data[1];

        return {
          date: item.date,
          discom: item.discom,
          dateIndex: dateIndexMap.get(item.date),
          dates: dateRange,
          month: getMonthFromDate(item.date),
          avg_daily_load_mw: +item.avg_daily_load_mw,
          daily_peak_load_mw: +item.daily_peak_load_mw,

          // Evening peak values
          evening_peak_load_mw: +eveningData.max_load,
          evening_peak_load_slot: eveningData.max_load_slot,
          evening_min_load_mw: +eveningData.min_load,
          evening_min_load_slot: eveningData.min_load_slot,
          evening_avg_load_mw: +eveningData.avg_load,

          // Morning peak values
          morning_peak_load_mw: +morningData.max_load,
          morning_peak_load_slot: morningData.max_load_slot,
          morning_min_load_mw: +morningData.min_load,
          morning_min_load_slot: morningData.min_load_slot,
          morning_avg_load_mw: +morningData.avg_load,

          formatted_data: [
            {
              time_period: eveningData.time_period,
              max_load: +eveningData.max_load,
              min_load: +eveningData.min_load,
              avg_load: +eveningData.avg_load,
              max_load_slot: eveningData.max_load_slot,
              min_load_slot: eveningData.min_load_slot,
            },
            {
              time_period: morningData.time_period,
              max_load: +morningData.max_load,
              min_load: +morningData.min_load,
              avg_load: +morningData.avg_load,
              max_load_slot: morningData.max_load_slot,
              min_load_slot: morningData.min_load_slot,
            },
          ],
        };
      });
    } catch (error) {
      console.error("Error fetching GSS Load Daily Discom data:", error);
      return [];
    }
  }

 export async function getRestrictedMonthlyDiscomGssLoad(
   startDate: string,
   endDate: string
 ): Promise<any[]> {
   try {
     const response: Promise<{
       success: boolean;
       message: string;
       min_date: string;
       max_date: string;
       count: number;
       data: any[];
     }> = await buildHttpResponse({
       endPoint: `rajasthan/gss-load-monthly-discom?start_date=${startDate}&end_date=${endDate}`,
       method: HttpMethod.GET,
     });

     const res = await response;
     const data = res.data;

     return data.map((item: any) => {
       const monthNames = [
         "Jan",
         "Feb",
         "Mar",
         "Apr",
         "May",
         "Jun",
         "Jul",
         "Aug",
         "Sep",
         "Oct",
         "Nov",
         "Dec",
       ];
       const yearShort = item.year.toString().slice(-2);
       const monthStr = `${monthNames[item.month - 1]}-${yearShort}`;

       return {
         month: monthStr,
         year: item.year,
         discom: item.discom,

         // Average load
         avg_daily_load_mw: parseFloat(item.average_load_mw?.toString() || "0"),

         // Overall peak load (used as daily_peak_load_mw)
         daily_peak_load_mw: parseFloat(item.peak_load_mw?.toString() || "0"),
         date_of_peak_load: item.date_of_peak_load,
         timeblock_of_peak_load: item.timeblock_of_peak_load,

         // Morning peak load
         morning_peak_load_mw: parseFloat(
           item.morning_peak_load_mw?.toString() || "0"
         ),
         date_of_morning_peak_load: item.date_of_morning_peak_load,
         timeblock_of_morning_peak_load: item.timeblock_of_morning_peak_load,

         // Evening peak load
         evening_peak_load_mw: parseFloat(
           item.evening_peak_load_mw?.toString() || "0"
         ),
         date_of_evening_peak_load: item.date_of_evening_peak_load,
         timeblock_of_evening_peak_load: item.timeblock_of_evening_peak_load,
       };
     });
   } catch (error) {
     console.error("Error fetching Monthly Discom GSS Load data:", error);
     return [];
   }
 }

   export async function getGssLoadRestrictedDistrictDailyDiscom(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<{
      success: boolean;
      message: string;
      min_date: string;
      max_date: string;
      count: number;
      data: any[];
    }> = await buildHttpResponse({
      endPoint: `rajasthan/gss-load-daily-discom-district?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    // Get unique dates for indexing
    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));

    return data.map((item) => {
      return {
        date: item.date,
        discom: item.discom,
        district: item.district,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        avg_daily_load_mw: parseFloat(item.avg_daily_load_mw.toString()),
        daily_peak_load_mw: parseFloat(item.daily_peak_load_mw.toString()),

        // Evening peak values
        evening_peak_load_mw: parseFloat(
          item.formatted_data[1].max_load.toString()
        ),
        evening_peak_load_slot: item.formatted_data[0].max_load_slot,
        evening_min_load_mw: parseFloat(
          item.formatted_data[1].min_load.toString()
        ),
        evening_min_load_slot: item.formatted_data[0].min_load_slot,
        evening_avg_load_mw: parseFloat(
          item.formatted_data[1].avg_load.toString()
        ),

        // Morning peak values
        morning_peak_load_mw: parseFloat(
          item.formatted_data[0].max_load.toString()
        ),
        morning_peak_load_slot: item.formatted_data[1].max_load_slot,
        morning_min_load_mw: parseFloat(
          item.formatted_data[0].min_load.toString()
        ),
        morning_min_load_slot: item.formatted_data[1].min_load_slot,
        morning_avg_load_mw: parseFloat(
          item.formatted_data[0].avg_load.toString()
        ),

        formatted_data: [
          {
            time_period: item.formatted_data[1].time_period,
            max_load: parseFloat(item.formatted_data[1].max_load.toString()),
            min_load: parseFloat(item.formatted_data[1].min_load.toString()),
            avg_load: parseFloat(item.formatted_data[1].avg_load.toString()),
            max_load_slot: item.formatted_data[1].max_load_slot,
            min_load_slot: item.formatted_data[1].min_load_slot,
          },
          {
            time_period: item.formatted_data[0].time_period,
            max_load: parseFloat(item.formatted_data[0].max_load.toString()),
            min_load: parseFloat(item.formatted_data[0].min_load.toString()),
            avg_load: parseFloat(item.formatted_data[0].avg_load.toString()),
            max_load_slot: item.formatted_data[0].max_load_slot,
            min_load_slot: item.formatted_data[0].min_load_slot,
          },
        ],
      };
    });
  } catch (error) {
    console.error(
      "Error fetching GSS Load Daily Discom District data:",
      error
    );
    return [];
  }
}
export async function getRestrictedGssLoadDailyTotal(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {    
    const response: Promise<{
      success: boolean;
      message: string;
      min_date: string;
      max_date: string;
      count: number;
      data: any[];
    }> = await buildHttpResponse({
      endPoint: `rajasthan/gss-load-daily-total?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;
    
    if (!data || data.length === 0) {
      return [];
    }

    // Get unique dates for indexing
    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));

    return data.map((item) => {
      return {
        date: item.date,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        avg_daily_load_mw: parseFloat(item.avg_daily_load_mw.toString()),
        daily_peak_load_mw: parseFloat(item.daily_peak_load_mw.toString()),

        // evening  peak values
        evening_peak_load_mw: parseFloat(
          item.formatted_data[1].max_load.toString()
        ),
        evening_peak_load_slot: item.formatted_data[1].max_load_slot,
        evening_min_load_mw: parseFloat(
          item.formatted_data[1].min_load.toString()
        ),
        evening_min_load_slot: item.formatted_data[1].min_load_slot,
        evening_avg_load_mw: parseFloat(
          item.formatted_data[1].avg_load.toString()
        ),

        // Moring peak values
        morning_peak_load_mw: parseFloat(
          item.formatted_data[0].max_load.toString()
        ),
        morning_peak_load_slot: item.formatted_data[0].max_load_slot,
        morning_min_load_mw: parseFloat(
          item.formatted_data[0].min_load.toString()
        ),
        morning_min_load_slot: item.formatted_data[0].min_load_slot,
        morning_avg_load_mw: parseFloat(
          item.formatted_data[0].avg_load.toString()
        ),

        formatted_data: [
          {
            time_period: item.formatted_data[0].time_period,
            max_load: parseFloat(item.formatted_data[0].max_load.toString()),
            min_load: parseFloat(item.formatted_data[0].min_load.toString()),
            avg_load: parseFloat(item.formatted_data[0].avg_load.toString()),
            max_load_slot: item.formatted_data[0].max_load_slot,
            min_load_slot: item.formatted_data[0].min_load_slot,
          },
          {
            time_period: item.formatted_data[1].time_period,
            max_load: parseFloat(item.formatted_data[1].max_load.toString()),
            min_load: parseFloat(item.formatted_data[1].min_load.toString()),
            avg_load: parseFloat(item.formatted_data[1].avg_load.toString()),
            max_load_slot: item.formatted_data[1].max_load_slot,
            min_load_slot: item.formatted_data[1].min_load_slot,
          }, 
        ],
      };
    });
  } catch (error) {
    console.error("[DAILY TOTAL API] Error fetching data:", error);
    
    if (error instanceof Error) {
      console.error("[DAILY TOTAL API] Error message:", error.message);
      console.error("[DAILY TOTAL API] Error stack:", error.stack);
    }
    
    return [];
  }
}

export async function getRestrictedGssLoadMonthlyTotal(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    
    const response: Promise<{
      success: boolean;
      message: string;
      min_date: string;
      max_date: string;
      count: number;
      data: any[];
    }> = await buildHttpResponse({
      endPoint: `rajasthan/gss-load-monthly-total?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;
    
    
    if (!data || data.length === 0) {
      return [];
    }

    // Helper function to format month
    const getMonthWithYear = (month: number, year: number): string => {
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const yearShort = year.toString().slice(-2);
      return `${monthNames[month - 1]}-${yearShort}`;
    };

    return data.map((item) => {
      return {
        // Add the formatted month field that the component expects
        month: getMonthWithYear(item.month, item.year),
        year: item.year,
        dates: `${startDate} to ${endDate}`,

        // Rename fields to match daily data structure
        avg_daily_load_mw: parseFloat(item.average_load_mw.toString()),
        daily_peak_load_mw: parseFloat(item.peak_load_mw.toString()),
        date_of_peak_load: item.date_of_peak_load,
        timeblock_of_peak_load: item.timeblock_of_peak_load,

        // Morning peak load
        morning_peak_load_mw: parseFloat(item.morning_peak_load_mw.toString()),
        date_of_morning_peak_load: item.date_of_morning_peak_load,
        timeblock_of_morning_peak_load: item.timeblock_of_morning_peak_load,

        // Evening peak load
        evening_peak_load_mw: parseFloat(item.evening_peak_load_mw.toString()),
        date_of_evening_peak_load: item.date_of_evening_peak_load,
        timeblock_of_evening_peak_load: item.timeblock_of_evening_peak_load,
      };
    });
  } catch (error) {
    console.error("[MONTHLY TOTAL API] Error fetching data:", error);
    
    if (error instanceof Error) {
      console.error("[MONTHLY TOTAL API] Error message:", error.message);
      console.error("[MONTHLY TOTAL API] Error stack:", error.stack);
    }
    
    return [];
  }
}
  export async function getrestrictedAreaGssLoadDaily(
    startDate: string,
    endDate: string
  ): Promise<any[]> {
    try {
      const response: Promise<{
        success: boolean;
        message: string;
        min_date: string;
        max_date: string;
        count: number;
        data: any[];
      }> = await buildHttpResponse({
        endPoint: `rajasthan/gss-load-daily?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

      const res = await response;
      const data = res.data;

      // Get unique dates for indexing
      const uniqueDates = Array.from(new Set(data.map((item) => item.date)));

      return data.map((item) => {
        return {
          date: item.date,
          discom: item.discom,
          divisional_headquarter: item.divisional_headquarter,
          district: item.district,
          area: item.station,
          dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
          dates: `${startDate} to ${endDate}`,
          month: getMonthFromDate(item.date),
          avg_daily_load_mw: parseFloat(item.avg_daily_load_mw.toString()),
          daily_peak_load_mw: parseFloat(item.daily_peak_load_mw.toString()),

          // Evening peak values
          evening_peak_load_mw: parseFloat(
            item.formatted_data[0].max_load.toString()
          ),
          evening_peak_load_slot: item.formatted_data[0].max_load_slot,
          evening_min_load_mw: parseFloat(
            item.formatted_data[0].min_load.toString()
          ),
          evening_min_load_slot: item.formatted_data[0].min_load_slot,
          evening_avg_load_mw: parseFloat(
            item.formatted_data[0].avg_load.toString()
          ),

          // Morning peak values
          morning_peak_load_mw: parseFloat(
            item.formatted_data[1].max_load.toString()
          ),
          morning_peak_load_slot: item.formatted_data[1].max_load_slot,
          morning_min_load_mw: parseFloat(
            item.formatted_data[1].min_load.toString()
          ),
          morning_min_load_slot: item.formatted_data[1].min_load_slot,
          morning_avg_load_mw: parseFloat(
            item.formatted_data[1].avg_load.toString()
          ),

          formatted_data: [
            {
              time_period: item.formatted_data[0].time_period,
              max_load: parseFloat(item.formatted_data[0].max_load.toString()),
              min_load: parseFloat(item.formatted_data[0].min_load.toString()),
              avg_load: parseFloat(item.formatted_data[0].avg_load.toString()),
              max_load_slot: item.formatted_data[0].max_load_slot,
              min_load_slot: item.formatted_data[0].min_load_slot,
            },
            {
              time_period: item.formatted_data[1].time_period,
              max_load: parseFloat(item.formatted_data[1].max_load.toString()),
              min_load: parseFloat(item.formatted_data[1].min_load.toString()),
              avg_load: parseFloat(item.formatted_data[1].avg_load.toString()),
              max_load_slot: item.formatted_data[1].max_load_slot,
              min_load_slot: item.formatted_data[1].min_load_slot,
            },
          ],
        };
      });
    } catch (error) {
      console.error("Error fetching GSS Load Daily data:", error);
      return [];
    }
  }
export async function getGssrestrictedAreaLoadMonthly(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<{
      success: boolean;
      message: string;
      min_date: string;
      max_date: string;
      count: number;
      data: any[];
    }> = await buildHttpResponse({
      endPoint: `rajasthan/gss-load-monthly?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    // Helper function to format month
    const getMonthWithYear = (month: number, year: number): string => {
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const yearShort = year.toString().slice(-2);
      return `${monthNames[month - 1]}-${yearShort}`;
    };

    return data.map((item) => {
      return {
        // Add the formatted month field that the component expects
        month: getMonthWithYear(item.month, item.year),
        year: item.year,
        discom: item.discom,
        divisional_headquarter: item.divisional_headquarter,
        district: item.district,
        area: item.station,
        dates: `${startDate} to ${endDate}`,

        // Rename fields to match daily data structure
        avg_daily_load_mw: parseFloat(item.average_load_mw.toString()),
        daily_peak_load_mw: parseFloat(item.peak_load_mw.toString()),
        date_of_peak_load: item.date_of_peak_load,
        timeblock_of_peak_load: item.timeblock_of_peak_load,

        // Morning peak load
        morning_peak_load_mw: parseFloat(item.morning_peak_load_mw.toString()),
        date_of_morning_peak_load: item.date_of_morning_peak_load,
        timeblock_of_morning_peak_load: item.timeblock_of_morning_peak_load,

        // Evening peak load
        evening_peak_load_mw: parseFloat(item.evening_peak_load_mw.toString()),
        date_of_evening_peak_load: item.date_of_evening_peak_load,
        timeblock_of_evening_peak_load: item.timeblock_of_evening_peak_load,
      };
    });
  } catch (error) {
    console.error("Error fetching GSS Load Monthly data:", error);
    return [];
  }
}

export async function getMonthlyRestrictedDistrictDiscomGssLoad(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<{
      success: boolean;
      message: string;
      min_date: string;
      max_date: string;
      count: number;
      data: any[];
    }> = await buildHttpResponse({
      endPoint: `rajasthan/gss-load-monthly-discom-district?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item: any) => {
      return {
        month: item.month,
        year: item.year,
        discom: item.discom,
        district: item.district,

        // Average load
        average_load_mw: parseFloat(item.average_load_mw?.toString() || "0"),

        // Overall peak load
        peak_load_mw: parseFloat(item.peak_load_mw?.toString() || "0"),
        date_of_peak_load: item.date_of_peak_load,
        timeblock_of_peak_load: item.timeblock_of_peak_load,

        // Morning peak load
        morning_peak_load_mw: parseFloat(
          item.morning_peak_load_mw?.toString() || "0"
        ),
        date_of_morning_peak_load: item.date_of_morning_peak_load,
        timeblock_of_morning_peak_load: item.timeblock_of_morning_peak_load,

        // Evening peak load
        evening_peak_load_mw: parseFloat(
          item.evening_peak_load_mw?.toString() || "0"
        ),
        date_of_evening_peak_load: item.date_of_evening_peak_load,
        timeblock_of_evening_peak_load: item.timeblock_of_evening_peak_load,
      };
    });
  } catch (error) {
    console.error(
      "Error fetching Monthly Discom District GSS Load data:",
      error
    );
    return [];
  }
}
export async function getMonthlyDiscomDrawalSchedule(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `rajasthan/getMonthlyDiscomDrawalSchedule?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item: any) => {
      return {
        month: item.month,
        year: item.year,
        discom: item.discom,
        average_drawal_mw: parseFloat(
          item.average_drawal_mw?.toString() || "0"
        ),
        average_schedule_mw: parseFloat(
          item.average_schedule_mw?.toString() || "0"
        ),

        // Peak drawal
        peak_drawal_mw: parseFloat(item.peak_drawal_mw?.toString() || "0"),
        date_of_peak_drawal: item.date_of_peak_drawal,
        timeblock_of_peak_drawal: item.timeblock_of_peak_drawal,

        // Peak schedule
        peak_schedule_mw: parseFloat(item.peak_schedule_mw?.toString() || "0"),
        date_of_peak_schedule: item.date_of_peak_schedule,
        timeblock_of_peak_schedule: item.timeblock_of_peak_schedule,

        // Morning peak drawal
        morning_peak_drawal_mw: parseFloat(
          item.morning_peak_drawal_mw?.toString() || "0"
        ),
        date_of_morning_peak_drawal: item.date_of_morning_peak_drawal,
        timeblock_of_morning_peak_drawal: item.timeblock_of_morning_peak_drawal,

        // Morning peak schedule
        morning_peak_schedule_mw: parseFloat(
          item.morning_peak_schedule_mw?.toString() || "0"
        ),
        date_of_morning_peak_schedule: item.date_of_morning_peak_schedule,
        timeblock_of_morning_peak_schedule:
          item.timeblock_of_morning_peak_schedule,

        // Evening peak drawal
        evening_peak_drawal_mw: parseFloat(
          item.evening_peak_drawal_mw?.toString() || "0"
        ),
        date_of_evening_peak_drawal: item.date_of_evening_peak_drawal,
        timeblock_of_evening_peak_drawal: item.timeblock_of_evening_peak_drawal,

        // Evening peak schedule
        evening_peak_schedule_mw: parseFloat(
          item.evening_peak_schedule_mw?.toString() || "0"
        ),
        date_of_evening_peak_schedule: item.date_of_evening_peak_schedule,
        timeblock_of_evening_peak_schedule:
          item.timeblock_of_evening_peak_schedule,
      };
    });
  } catch (error) {
    console.error("Error fetching Monthly Discom Drawal Schedule data:", error);
    return [];
  }
}


// Monthly Peak API
export async function getRajasthanMonthlyPeakDiscom(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `rajasthan/getMonthlyPeakDemand?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item: any) => {
      return {
        month: item.month,
        year: item.year,
        average_mw: parseFloat(item.average_mw.toString()),
        peak_mw: parseFloat(item.peak_mw.toString()),
        date_of_peak: item.date_of_peak,
        timeblock_of_peak: item.timeblock_of_peak,
        morning_peak_mw: parseFloat(item.morning_peak_mw.toString()),
        date_of_morning_peak: item.date_of_morning_peak,
        timeblock_of_morning_peak: item.timeblock_of_morning_peak,
        evening_peak_mw: parseFloat(item.evening_peak_mw.toString()),
        date_of_evening_peak: item.date_of_evening_peak,
        timeblock_of_evening_peak: item.timeblock_of_evening_peak,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Monthly Peak data:", error);
    return [];
  }
}

export async function getDailyTotalDrawalSchedule(
  startDate: string,
  endDate: string,
  sourcesParam: string = ""
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `rajasthan/getDailyTotalDrawalSchedule?start_date=${startDate}&end_date=${endDate}${sourcesParam}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    return res;
  } catch (error) {
    console.error("Error fetching Haryana Generation Profile data:", error);
    return [];
  }
}
export async function getMonthlyTotalDrawalSchedule(
  startDate: string,
  endDate: string,
  sourcesParam: string = ""
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `rajasthan/getMonthlyTotalDrawalSchedule?start_date=${startDate}&end_date=${endDate}${sourcesParam}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    return res;
  } catch (error) {
    console.error("Error fetching Haryana Generation Profile data:", error);
    return [];
  }
}
export async function getTotalDrawalScheduleMetrics(
  startDate: string,
  endDate: string,
  sourcesParam: string = ""
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `rajasthan/getTotalDrawalScheduleMetrics?start_date=${startDate}&end_date=${endDate}${sourcesParam}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    return res;
  } catch (error) {
    console.error("Error fetching Haryana Generation Profile data:", error);
    return [];
  }
}

export async function getRajasthanDrawalScheduleForecastMetrics(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getDrawalScheduleForecastMetrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const data = await response;

    // Transform the data to match your application's structure
    return data.map((item: any) => ({
      ...item,
      // Ensure consistent naming
      block: item.block,
      discom: item.discom,
      model: item.model,
      forecast_type: item.forecast_type, // "T+1" or "T+2"
      time_string: item.time_string,

      // Schedule metrics
      min_schedule: item.min_schedule || 0,
      max_schedule: item.max_schedule || 0,
      avg_schedule: item.avg_schedule || 0,
      mode_schedule_window_formula: item.mode_schedule_window_formula || 0,
      date_of_min_schedule: item.date_of_min_schedule,
      date_of_max_schedule: item.date_of_max_schedule,

      // Drawal metrics
      min_drawal: item.min_drawal || 0,
      max_drawal: item.max_drawal || 0,
      avg_drawal: item.avg_drawal || 0,
      mode_drawal_window_formula: item.mode_drawal_window_formula || 0,
      date_of_min_drawal: item.date_of_min_drawal,
      date_of_max_drawal: item.date_of_max_drawal,
    }));
  } catch (error) {
    console.error("Error fetching Rajasthan forecast metrics:", error);
    return [];
  }
}

export async function getRajasthanDailyPeakForecast(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getDailyDrawalScheduleForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const data = await response;

    // Return the data array, filtering for Total discom only
    if (data && Array.isArray(data.data)) {
      return data.data
        .filter((item: any) => item.discom === "Total")
        .map((item: any) => ({
          date: item.date,
          discom: item.discom,
          model: item.model,
          forecast_type: item.forecast_type, // "T+1" or "T+2"
          avg_daily_schedule_mw: item.avg_daily_schedule_mw || 0,
          daily_peak_schedule_mw: item.daily_peak_schedule_mw || 0,
          avg_daily_drawal_mw: item.avg_daily_drawal_mw || 0,
          daily_peak_drawal_mw: item.daily_peak_drawal_mw || 0,
          formatted_data: item.formatted_data || [],
        }));
    }

    return [];
  } catch (error) {
    console.error("Error fetching daily peak forecast:", error);
    return [];
  }
}

export async function getRajasthanMonthlyPeakForecast(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `rajasthan/getMonthlyDrawalScheduleForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const data = await response;

    // Return the data array, filtering for Total discom only
    if (data && Array.isArray(data.data)) {
      return data.data
        .filter((item: any) => item.discom === "Total")
        .map((item: any) => ({
          month: item.month,
          year: item.year,
          discom: item.discom,
          model: item.model,
          forecast_type: item.forecast_type, // "T+1" or "T+2"
          average_schedule_mw: item.average_schedule_mw || 0,
          peak_schedule_mw: item.peak_schedule_mw || 0,
          date_of_peak_schedule: item.date_of_peak_schedule,
          block_of_peak_schedule: item.block_of_peak_schedule,
          morning_peak_schedule_mw: item.morning_peak_schedule_mw || 0,
          date_of_morning_peak_schedule: item.date_of_morning_peak_schedule,
          block_of_morning_peak_schedule: item.block_of_morning_peak_schedule,
          evening_peak_schedule_mw: item.evening_peak_schedule_mw || 0,
          date_of_evening_peak_schedule: item.date_of_evening_peak_schedule,
          block_of_evening_peak_schedule: item.block_of_evening_peak_schedule,
          average_drawal_mw: item.average_drawal_mw || 0,
          peak_drawal_mw: item.peak_drawal_mw || 0,
          date_of_peak_drawal: item.date_of_peak_drawal,
          block_of_peak_drawal: item.block_of_peak_drawal,
          morning_peak_drawal_mw: item.morning_peak_drawal_mw || 0,
          date_of_morning_peak_drawal: item.date_of_morning_peak_drawal,
          block_of_morning_peak_drawal: item.block_of_morning_peak_drawal,
          evening_peak_drawal_mw: item.evening_peak_drawal_mw || 0,
          date_of_evening_peak_drawal: item.date_of_evening_peak_drawal,
          block_of_evening_peak_drawal: item.block_of_evening_peak_drawal,
        }));
    }

    return [];
  } catch (error) {
    console.error("Error fetching monthly peak forecast:", error);
    return [];
  }
}

export async function getRajasthanSurplusDeficitMetrics(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `rajasthan/surplus-deficit-metrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    
    if (!res || res.length === 0) {
      console.warn("[SURPLUS-DEFICIT API] No data returned");
      return [];
    }
    
    console.log(`[SURPLUS-DEFICIT API] Fetched ${res.length} records`);

    const mappedData = res.map((item: any) => {
      return {
        slot: item.time_block,
        
        // Drawal metrics
        min_drawal: parseFloat(item.min_drawal?.toString() || "0"),
        date_of_min_drawal: item.date_of_min_drawal,
        max_drawal: parseFloat(item.max_drawal?.toString() || "0"),
        date_of_max_drawal: item.date_of_max_drawal,
        avg_drawal: parseFloat(item.avg_drawal?.toString() || "0"),
        mode_drawal: parseFloat(item.mode_drawal?.toString() || "0"),
        
        // Total Generation + Procurement metrics
        min_total_gen_proc: parseFloat(item.min_total_gen_proc?.toString() || "0"),
        date_of_min_total_gen_proc: item.date_of_min_total_gen_proc,
        max_total_gen_proc: parseFloat(item.max_total_gen_proc?.toString() || "0"),
        date_of_max_total_gen_proc: item.date_of_max_total_gen_proc,
        avg_total_gen_proc: parseFloat(item.avg_total_gen_proc?.toString() || "0"),
        mode_total_gen_proc: parseFloat(item.mode_total_gen_proc?.toString() || "0"),
        
        // Surplus/Deficit metrics
        min_surplus_deficit: parseFloat(item.min_surplus_deficit?.toString() || "0"),
        date_of_min_surplus_deficit: item.date_of_min_surplus_deficit,
        max_surplus_deficit: parseFloat(item.max_surplus_deficit?.toString() || "0"),
        date_of_max_surplus_deficit: item.date_of_max_surplus_deficit,
        avg_surplus_deficit: parseFloat(item.avg_surplus_deficit?.toString() || "0"),
        mode_surplus_deficit: parseFloat(item.mode_surplus_deficit?.toString() || "0"),
        
        // Surplus/Deficit percentage metrics
        min_surplus_deficit_pct: parseFloat(item.min_surplus_deficit_pct?.toString() || "0"),
        max_surplus_deficit_pct: parseFloat(item.max_surplus_deficit_pct?.toString() || "0"),
        avg_surplus_deficit_pct: parseFloat(item.avg_surplus_deficit_pct?.toString() || "0"),
        mode_surplus_deficit_pct: parseFloat(item.mode_surplus_deficit_pct?.toString() || "0"),
      };
    });
    
    return mappedData;
    
  } catch (error) {
    console.error("[SURPLUS-DEFICIT API] Error fetching data:", error);
    
    if (error instanceof Error) {
      console.error("[SURPLUS-DEFICIT API] Error message:", error.message);
      console.error("[SURPLUS-DEFICIT API] Error stack:", error.stack);
    }
    
    return [];
  }
}
export async function getRajasthanMonthlySurplusDeficit(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `rajasthan/surplus-deficit-monthly?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item: any) => {
      return {
        year: item.year,
        month: item.month,
        
        // Drawal metrics
        average_drawal_mw: parseFloat(item.average_drawal_mw?.toString() || "0"),
        peak_drawal_mw: parseFloat(item.peak_drawal_mw?.toString() || "0"),
        date_of_peak_drawal: item.date_of_peak_drawal,
        block_of_peak_drawal: item.block_of_peak_drawal,
        morning_peak_drawal_mw: parseFloat(item.morning_peak_drawal_mw?.toString() || "0"),
        date_of_morning_peak_drawal: item.date_of_morning_peak_drawal,
        block_of_morning_peak_drawal: item.block_of_morning_peak_drawal,
        evening_peak_drawal_mw: parseFloat(item.evening_peak_drawal_mw?.toString() || "0"),
        date_of_evening_peak_drawal: item.date_of_evening_peak_drawal,
        block_of_evening_peak_drawal: item.block_of_evening_peak_drawal,
        
        // Generation/Procurement metrics
        average_total_gen_proc_mw: parseFloat(item.average_total_gen_proc_mw?.toString() || "0"),
        peak_total_gen_proc_mw: parseFloat(item.peak_total_gen_proc_mw?.toString() || "0"),
        date_of_peak_total_gen_proc: item.date_of_peak_total_gen_proc,
        block_of_peak_total_gen_proc: item.block_of_peak_total_gen_proc,
        morning_peak_total_gen_proc_mw: parseFloat(item.morning_peak_total_gen_proc_mw?.toString() || "0"),
        date_of_morning_peak_total_gen_proc: item.date_of_morning_peak_total_gen_proc,
        block_of_morning_peak_total_gen_proc: item.block_of_morning_peak_total_gen_proc,
        evening_peak_total_gen_proc_mw: parseFloat(item.evening_peak_total_gen_proc_mw?.toString() || "0"),
        date_of_evening_peak_total_gen_proc: item.date_of_evening_peak_total_gen_proc,
        block_of_evening_peak_total_gen_proc: item.block_of_evening_peak_total_gen_proc,
        
        // Surplus/Deficit metrics
        average_surplus_deficit_mw: parseFloat(item.average_surplus_deficit_mw?.toString() || "0"),
        peak_surplus_deficit_mw: parseFloat(item.peak_surplus_deficit_mw?.toString() || "0"),
        date_of_peak_surplus_deficit: item.date_of_peak_surplus_deficit,
        block_of_peak_surplus_deficit: item.block_of_peak_surplus_deficit,
        morning_peak_surplus_deficit_mw: parseFloat(item.morning_peak_surplus_deficit_mw?.toString() || "0"),
        date_of_morning_peak_surplus_deficit: item.date_of_morning_peak_surplus_deficit,
        block_of_morning_peak_surplus_deficit: item.block_of_morning_peak_surplus_deficit,
        evening_peak_surplus_deficit_mw: parseFloat(item.evening_peak_surplus_deficit_mw?.toString() || "0"),
        date_of_evening_peak_surplus_deficit: item.date_of_evening_peak_surplus_deficit,
        block_of_evening_peak_surplus_deficit: item.block_of_evening_peak_surplus_deficit,
        
        // Percentage metrics
        average_surplus_deficit_pct: parseFloat(item.average_surplus_deficit_pct?.toString() || "0"),
        peak_surplus_deficit_pct: parseFloat(item.peak_surplus_deficit_pct?.toString() || "0"),
        date_of_peak_surplus_deficit_pct: item.date_of_peak_surplus_deficit_pct,
        block_of_peak_surplus_deficit_pct: item.block_of_peak_surplus_deficit_pct,
        morning_peak_surplus_deficit_pct: parseFloat(item.morning_peak_surplus_deficit_pct?.toString() || "0"),
        date_of_morning_peak_surplus_deficit_pct: item.date_of_morning_peak_surplus_deficit_pct,
        block_of_morning_peak_surplus_deficit_pct: item.block_of_morning_peak_surplus_deficit_pct,
        evening_peak_surplus_deficit_pct: parseFloat(item.evening_peak_surplus_deficit_pct?.toString() || "0"),
        date_of_evening_peak_surplus_deficit_pct: item.date_of_evening_peak_surplus_deficit_pct,
        block_of_evening_peak_surplus_deficit_pct: item.block_of_evening_peak_surplus_deficit_pct,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Monthly Surplus/Deficit data:", error);
    return [];
  }
}

export async function getRajasthanDailySurplusDeficit(
  startDate: string,
  endDate: string
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `rajasthan/surplus-deficit-daily?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item: any) => {
      return {
        date: item.date,
        
        // Daily average metrics
        avg_daily_drawal_mw: parseFloat(item.avg_daily_drawal_mw?.toString() || "0"),
        daily_peak_drawal_mw: parseFloat(item.daily_peak_drawal_mw?.toString() || "0"),
        avg_daily_total_gen_proc_mw: parseFloat(item.avg_daily_total_gen_proc_mw?.toString() || "0"),
        daily_peak_total_gen_proc_mw: parseFloat(item.daily_peak_total_gen_proc_mw?.toString() || "0"),
        avg_daily_surplus_deficit_mw: parseFloat(item.avg_daily_surplus_deficit_mw?.toString() || "0"),
        daily_peak_surplus_deficit_mw: parseFloat(item.daily_peak_surplus_deficit_mw?.toString() || "0"),
        avg_daily_surplus_deficit_pct: parseFloat(item.avg_daily_surplus_deficit_pct?.toString() || "0"),
        daily_peak_surplus_deficit_pct: parseFloat(item.daily_peak_surplus_deficit_pct?.toString() || "0"),
        
        // Formatted data by time period (Morning/Evening)
        formatted_data: item.formatted_data?.map((period: any) => ({
          time_period: period.time_period,
          
          // Drawal metrics
          avg_drawal: parseFloat(period.avg_drawal?.toString() || "0"),
          max_drawal: parseFloat(period.max_drawal?.toString() || "0"),
          min_drawal: parseFloat(period.min_drawal?.toString() || "0"),
          max_drawal_block: period.max_drawal_block,
          min_drawal_block: period.min_drawal_block,
          
          // Generation/Procurement metrics
          avg_total_gen_proc: parseFloat(period.avg_total_gen_proc?.toString() || "0"),
          max_total_gen_proc: parseFloat(period.max_total_gen_proc?.toString() || "0"),
          min_total_gen_proc: parseFloat(period.min_total_gen_proc?.toString() || "0"),
          max_total_gen_proc_block: period.max_total_gen_proc_block,
          min_total_gen_proc_block: period.min_total_gen_proc_block,
          
          // Surplus/Deficit metrics
          avg_surplus_deficit: parseFloat(period.avg_surplus_deficit?.toString() || "0"),
          max_surplus_deficit: parseFloat(period.max_surplus_deficit?.toString() || "0"),
          min_surplus_deficit: parseFloat(period.min_surplus_deficit?.toString() || "0"),
          max_surplus_deficit_block: period.max_surplus_deficit_block,
          min_surplus_deficit_block: period.min_surplus_deficit_block,
          
          // Percentage metrics
          avg_surplus_deficit_pct: parseFloat(period.avg_surplus_deficit_pct?.toString() || "0"),
          max_surplus_deficit_pct: parseFloat(period.max_surplus_deficit_pct?.toString() || "0"),
          min_surplus_deficit_pct: parseFloat(period.min_surplus_deficit_pct?.toString() || "0"),
        })) || [],
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Daily Surplus/Deficit data:", error);
    return [];
  }
}

// Procurement Optimizer Session

export async function fetchProcurementRuvnlSession(
  startDate: string,
  endDate: string
) {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/start-session?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.POST,
    body: {
      start_date: startDate,
      end_date: endDate,
    },
  });
  return response;
}

export async function getProcurementRuvnlSession() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/get-session`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getStatusRuvnlTraderOffersData() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/get-status-power`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function StartSimulationRuvnlProcurementData(
  TraderOffersData: any
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/start-simulation`,
    method: HttpMethod.POST,
    noCache: true,
    body: TraderOffersData,
  });

  return response as ApiResponse;
}
export async function UpdateTraderRuvnlOffersData(TraderOffersData: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/update-trader-offers`,
    method: HttpMethod.POST,
    noCache: true,
    body: TraderOffersData,
  });

  return response as ApiResponse;
}

export async function fetchTraderRuvnlOffersData() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/get-trader-offers`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function AddTraderRuvnlOffersData(TraderOffersData: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/add-trader-offers`,
    method: HttpMethod.POST,
    noCache: true,
    body: TraderOffersData,
  });

  return response as ApiResponse;
}

export async function AddSurplusDeficitRuvnlData(SurplusDeficitData: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/upload-deficit-data`,
    method: HttpMethod.POST,
    noCache: true,
    body: SurplusDeficitData,
  });

  return response as ApiResponse;
}
export async function fetchProcurementRuvnlSimulationMetricsData() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/all-metrics`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function UpdateTraderRuvnlOffersToggleData(TraderOffersData: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/toggle-trader-offers`,
    method: HttpMethod.POST,
    noCache: true,
    body: TraderOffersData,
  });

  return response as ApiResponse;
}
export async function getStatusTraderRuvnlOffersData() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/get-status-power`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimalTraderRuvnlOffersData() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/get-optimal-trader-offers`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchSimulationRuvnlProcurementData() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/simulation-data`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchProcurementRuvnlCummulativeData() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/simulation-data-cummulative`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchOptimalProcurementRuvnlData() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/optimal-data`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchOptimalProcurementRuvnlCummulativeData() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/optimal-data-cummulative`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchProcurementRuvnlStatistics() {
  const response = await buildHttpResponse({
    endPoint: `rajasthan/procurement/summary-metrics`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
